// removed by extract-text-webpack-plugin
module.exports = {"img_banner":"BJhbDq88XMSFVhZk3CIOo","banner_big":"_236fOqmqbl34Ad3xkKFn_r","banner_small":"JQDHIqhKKkLuQWvkZsYHz"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImageChangeComponent/ImageChangeComponent.scss
 ** module id = 983
 ** module chunks = 0
 **/